import { Component, Input } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';


@Component({
    selector: 'grid-header-checkbox',
    template: `<input type="checkbox" style="width: 20px;height: 20px;vertical-align: middle;" [checked]="params.value" (change)="headerCheckChanged($event.currentTarget.checked)">`,
    standalone: false
})

export class HeaderCheckboxComponent implements IHeaderAngularComp {
	@Input() cell: any;

	public params: any;
	checked: any;

	agInit(params: any): void {
		this.params = params;

		if (params.column.colDef.headerComponentFramework.checked == true) {  // NOSONAR
			this.checked = true;
		} else {
			this.checked = false;
		}
	}

	refresh(params: any): boolean {
		this.params = params;
		this.checked = false;
		return true;
	}

	headerCheckChanged(event) {
		this.checked = event
		this.params.context.componentParent.headerCheckChanged(event);
	}


	constructor() {
		this.checked = false;
	}

}
